import React, { useEffect, useState } from "react";
import { Card, Row } from "react-bootstrap";
import Dialog from "@material-ui/core/Dialog";
import style from "./ThemesLayout.module.css";
import Button from "@material-ui/core/Button";
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";
import ThemeDescriptionCard from "./ThemeComponents/ThemeDescriptionCard";
import AddSaveNewTheme from "./ThemeComponents/AddSaveNewTheme";
import { ThemeJSON } from "../../Theme/ThemeJSON";
import { useTranslation } from "react-i18next";
import CustomizedAlert from "../../../../ReusableComponents/Alert/CustomizedAlert";
import {
  userDefinedThemes,
  systemDefinedThemes,
} from "../../../../components/IFormDesignerLayout/RequestLogic";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: 1500,
    color: "#fff",
    "& .MuiPaper-root.MuiDialog-paper":{
      maxWidth:"unset !important"
    }
  },
}));

const ThemeSelector = (props) => {
  const { t } = useTranslation();

  const [themeSelectedToApply, setThemeSelectedToApply] = useState(
    Object.assign({}, props.themeList && props.themeList["appliedTheme"])
  );

  const [themeSelectedApplied, setThemeSelectedApplied] = useState();

  const [showThemeNameBackdrop, setShowThemeNameBackdrop] = useState(false);

  const [alertData, setAlertData] = useState({
    open: false,
    showConfirm: "showNotification",
  });
  const [showHelperText, setShowHelperText] = useState(false);

  const [selectedThemeSystem, setSelectedThemeSystem] = useState(-1);
  const [selectedThemeCustom, setSelectedThemeCustom] = useState(-1);

  const [userDefinedThemes1, setUserDefinedThemes1] = useState({
    userDefinedThemes2: [],
  });

  function handleSelectedTheme(themeType, themeIndex, selectedTheme) {
    if (themeType === "userDefinedThemes")
      selectedTheme = userDefinedThemes1?.userDefinedThemes2?.[themeIndex];
    console.log(
      "userdefinedThemes",
      userDefinedThemes1,
      userDefinedThemes1.userDefinedThemes2
    );
    if (themeType !== "appliedTheme") {
      if (props.themeList && props.themeList["appliedTheme"]) {
        setThemeSelectedApplied(selectedTheme);
      } else if (props.themeList) {
        props.themeList["appliedTheme"] =
          props.themeList[themeType][themeIndex];
        setThemeSelectedApplied(props.themeList[themeType][themeIndex]);
      }
    }

    if (themeType === "systemDefinedThemes") {
      setSelectedThemeSystem(themeIndex);
      setSelectedThemeCustom(-1);
    } else if (themeType === "userDefinedThemes") {
      setSelectedThemeCustom(themeIndex);
      setSelectedThemeSystem(-1);
    }
  }

  function handleUploadedTheme(event) {
    var flag34 = 0;
    if (event.target.files && event.target.files[0]) {
      const fileReader = new FileReader();
      fileReader.readAsText(event.target.files[0], "UTF-8");
      fileReader.onload = (event) => {
        if (event.target.result && props.handleThemeList) {
          let updateUserDefinedTheme = {};
          console.log("naisa5", JSON.parse(event.target.result));
          updateUserDefinedTheme = userDefinedThemes1?.userDefinedThemes2.find(
            (theme) =>
              theme?.themeName === JSON.parse(event.target.result)?.themeName
          );
          if (
            updateUserDefinedTheme &&
            Object.keys(updateUserDefinedTheme).length !== 0
          )
            flag34 = 1;
          if (flag34 === 0) {
            let themeList1 = userDefinedThemes1?.["userDefinedThemes2"];
            themeList1.push(JSON.parse(event.target.result));
            setUserDefinedThemes1({
              ...userDefinedThemes1,
              userDefinedThemes2: themeList1,
            });
            props.handleThemeList("add", JSON.parse(event.target.result));
          }
          if (flag34 === 0) {
            setAlertData({
              open: true,
              showConfirm: "showNotification",
              alertType: "success",
              vertical: "bottom",
              horizontal: "left",
              alertContentMsg: "THEME_UPLOAD_SUCCESSFULLY",
              autoHideDuration: 4000,
            });
          }
          if (flag34 === 1) {
            setAlertData({
              open: true,
              showConfirm: "showNotification",
              alertType: "error",
              alertContentMsg: "Theme with same name already exists",
              autoHideDuration: 4000,
            });
          }
          event.target.value = "";
          event.target.result = "";
          event.target.files = null;
        }
      };
    }
  }

  function handleThemeNameBackdrop(action, themeName) {
    if (themeName === "") {
      setAlertData({
        open: true,
        showConfirm: "showNotification",
        alertType: "error",
        alertContentMsg: "ENTER_THEME_NAME",
      });
      setShowHelperText(true);
    } else {
      if (action === "Add" && themeName && props.handleThemeList) {
        var newTheme = Object.assign({}, ThemeJSON["defaultNewTheme"]);
        newTheme["themeName"] = themeName;
        props.handleThemeList("add", newTheme);
      }
      setShowThemeNameBackdrop(false);
      setAlertData(undefined);
      setShowHelperText(false);
    }
  }

  useEffect(() => {}, [themeSelectedToApply]);

  useEffect(() => {
    var allthemes = [];

    var themeNames = [];

    userDefinedThemes()
      .then((response) => {
        Object.values(response.data).map((themeContent, themeIndex) => {
          try {
            console.log("ThemeSelector", response.data);
            allthemes.push(JSON.parse(themeContent));
            themeNames.push(Object.keys(response.data)?.[themeIndex]);
          } catch {
            console.log(
              "issue in theme reading",
              Object.keys(response.data)?.[themeIndex]
            );
          }
        });

        props.setThemeList({
          ...props.themeList,
          userDefinedThemes: allthemes,
        });
        setUserDefinedThemes1({
          ...userDefinedThemes1,
          userDefinedThemes2: allthemes,
        });
      })
      .catch(function (error) {});
  }, []);

  useEffect(() => {
    var allthemes = [];

    var themeNames = [];
    systemDefinedThemes()
      .then((response) => {
        Object.values(response.data).map((themeContent) => {
          allthemes.push(JSON.parse(themeContent));
          themeNames.push(JSON.parse(themeContent).themeName);
          props.setThemeList({
            ...props.themeList,
            systemDefinedThemes: allthemes,
          });
        });
      })
      .catch(function (error) {});
  }, []);
  function deleteThemeUI(index) {
    var themeList = [];
    var themeList1 = [];
    themeList = props.themeList["userDefinedThemes"];
    themeList1 = userDefinedThemes1["userDefinedThemes2"];
    themeList.splice(index, 1);
    themeList1.splice(index, 1);
    props.setThemeList({ ...props.themeList, userDefinedThemes: themeList });
    setUserDefinedThemes1({
      ...userDefinedThemes1,
      userDefinedThemes2: themeList1,
    });
  }
  useEffect(() => {
    document.getElementById("backdropDiv")?.focus();
  }, []);
  function handleEscapeKey(e) {
    if (e.code === "Escape" && props?.showTheme === "themeSelector") {
      props.handleThemeSelector("Cancel");
    }
  }

  const classes = useStyles();
  return (
    <Dialog
        open={true}
        // classes={{ paper: classes.dialog, root: classes.root, container: classes.container  }}
        // onClose={handleClose}
        // container={() => document.getElementById("canvasId")}
        className={`${classes.backdrop} formBuilder_main_app`}
        style={{ zIndex: 1298 }}
        disableBackdropClick={false}
        onClose={(e) => handleEscapeKey(e)}
        // key={props?.subFormListviewJson?.id}
        // id={`${props.subFormListviewJson.id}_advListviewPopup`}
      >
    {/* // <Backdrop className={classes.backdrop} open={true}> */}
      <div
        tabIndex="0"
        onKeyDown={(e) => handleEscapeKey(e)}
        id="backdropDiv"
        style={{ overflowY: "auto" }}
        className={style.themeSelectorBackdropDiv}
      >
        <Row className={style.themeSelectorBackdropHeader}>
          {t("Theme")}
          <div>
            <Button
              disableFocusRipple
              disableRipple
              tabIndex={0}
              id="uploadthemebutton"
              className={[
                style.themeFooterButtons,
                style.uploadThemeButton,
                "formBuilder-MuiButton-outlined",
              ].join(" ")}
              onClick={(e) => {
                document.getElementById("uploadthemeinput").click();
                e.target.value = "";
              }}
            >
              {t("Upload Theme")}
            </Button>
            <input
              aria-label={"Upload theme"}
              type="file"
              id="uploadthemeinput"
              className={style.hiddenuploadInput}
              onChange={(event) => {
                handleUploadedTheme(event);
                event.target.value = "";
              }}
              accept=".json,application/json"
            />
          </div>
        </Row>
        <div className={style.themeTypeCardParent}>
          <Card className={style.themeTypeCard}>
            <Card.Title className={style.themeTypeHeader}>
              {t("Applied Theme")}
            </Card.Title>
            <Card.Body className={style.themeTypeParentBody}>
              {props.themeList && props.themeList["appliedTheme"] && (
                <ThemeDescriptionCard
                  key={
                    themeSelectedToApply && themeSelectedToApply["themeName"]
                      ? themeSelectedToApply["themeName"]
                      : 1
                  }
                  themeType={"appliedTheme"}
                  themeIndex={0}
                  themeApplied={true}
                  themeSelected={true}
                  themeDetails={themeSelectedToApply}
                  handleSelectedTheme={(themeType, themeIndex, selectedTheme) =>
                    handleSelectedTheme(themeType, themeIndex, selectedTheme)
                  }
                />
              )}
            </Card.Body>
          </Card>
          <Card className={style.themeTypeCard}>
            <Card.Title className={style.themeTypeHeader}>
              {t("System Defined Themes")}
            </Card.Title>
            <Card.Body className={style.themeTypeParentBody}>
              {props.themeList &&
                props.themeList["systemDefinedThemes"] &&
                props.themeList["systemDefinedThemes"].map((theme, index) => {
                  return (
                    <ThemeDescriptionCard
                      themeType={"systemDefinedThemes"}
                      themeIndex={index}
                      themeDetails={theme}
                      handleSelectedTheme={(
                        themeType,
                        themeIndex,
                        selectedTheme
                      ) =>
                        handleSelectedTheme(
                          themeType,
                          themeIndex,
                          selectedTheme
                        )
                      }
                      selectedThemeSystem={selectedThemeSystem}
                    />
                  );
                })}
            </Card.Body>
          </Card>
          <Card className={style.themeTypeCard}>
            <Card.Title className={style.themeTypeHeader}>
              {t("User Defined Themes")}
            </Card.Title>
            <Card.Body className={style.themeTypeParentBody}>
              {userDefinedThemes1.userDefinedThemes2.map((theme, index) => {
                return (
                  <ThemeDescriptionCard
                    themeType={"userDefinedThemes"}
                    themeIndex={index}
                    themeDetails={theme}
                    handleSelectedTheme={(
                      themeType,
                      themeIndex,
                      selectedTheme
                    ) =>
                      handleSelectedTheme(themeType, themeIndex, selectedTheme)
                    }
                    deleteThemeUI={deleteThemeUI}
                    userDefinedThemes1={userDefinedThemes1}
                    selectedThemeCustom={selectedThemeCustom}
                  />
                );
              })}
            </Card.Body>
          </Card>
        </div>
        <Row
          className={style.themeSelectorBackdropFooter}
          dir={
            window?.psh_configs?.selectedLanguage === "ar" ||
            window?.psh_configs?.selectedLanguage === "ar-SA"
              ? "rtl"
              : "ltr"
          }
        >
          <Button
            disableFocusRipple
            disableRipple
            tabIndex={0}
            className={[
              style.themeFooterButtons,
              style.cancelButton,
              "formBuilder-MuiButton-outlined",
            ].join(" ")}
            onClick={() => props.handleThemeSelector("Cancel")}
          >
            {t("Cancel")}
          </Button>

          <Button
            disableFocusRipple
            disableRipple
            tabIndex={0}
            className={[
              style.themeFooterButtons,
              style.saveButton,
              "formBuilder-MuiButton-outlined",
            ].join(" ")}
            onClick={() =>
              props.handleThemeSelector("Apply", themeSelectedApplied)
            }
          >
            {t("Apply")}
          </Button>

          
        </Row>
        {showThemeNameBackdrop === true ? (
          <AddSaveNewTheme
            key={showThemeNameBackdrop}
            handleThemeNameBackdrop={(action, themeName) =>
              handleThemeNameBackdrop(action, themeName)
            }
            showHelperText={showHelperText}
            themeAction={t("Add Theme")}
            button1Name={t("Add")}
          />
        ) : (
          <></>
        )}
      </div>
      {alertData.open === true && <CustomizedAlert alertData={alertData} />}
    {/* </Backdrop> */}
    </Dialog>
  );
};

export default ThemeSelector;
